

window.addEventListener('DOMContentLoaded', () => {

  const variant_color = document.querySelectorAll(".variant_color");
  if (variant_color && variant_color != undefined){
    variant_color.forEach((color) => {
      color.addEventListener("mouseenter", function(){
        var img_src = color.dataset.image;
        var variant_id = color.dataset.variant;
        var product_section = color.closest('.variants_container').dataset.product;
        var media_cont = document.querySelector('.card__media[data-product='+ product_section + ']');
        var media_img = media_cont.querySelector('img');
        var media_second = media_cont.querySelector('.media_second');
        media_img.setAttribute('src', img_src);
        media_img.setAttribute('srcset', img_src);
        media_second.style.display = 'none';
      });
      color.addEventListener("mouseleave", function(){
        var product_section = color.closest('.variants_container').dataset.product;
        var media_cont = document.querySelector('.card__media[data-product='+ product_section + ']');
        var media_second = media_cont.querySelector('.media_second');
        media_second.style.display = 'block';
      });
    });
  }


  
  const cart_wrapper = document.querySelector(".cart__footer-wrapper");
  const cart_items = document.querySelector(".cart-container-wrap cart-items");

  if(cart_wrapper && cart_wrapper != undefined && cart_items && cart_items != undefined && document.documentElement.clientWidth < 786){
    // cart_items.insertAdjacentHTML('afterend', cart_wrapper);
    cart_items.append(cart_wrapper);
  }





  const variant_add = document.querySelectorAll(".var-pro-add");
  if (variant_add && variant_add != undefined){
    variant_add.forEach((variant) => {
      variant.addEventListener('click', function(e){
        e.preventDefault();
        var id = variant.dataset.var;        
        var elm_car = document.querySelector('[data-form-cart="'+id+'"]');
        elm_car.querySelector('button[type="submit"]').click();
      });
    });
  }

  

  const pro_view = document.querySelector(".product .product__info-wrapper");
  const thumb =  document.querySelector(".product__media-wrapper .thumbnail-slider");

  if (thumb && thumb != undefined){
    var viewed = isproInViewport(pro_view);

    if(viewed === true){
      // thumb.classList.add('flx');
    }else{
      // thumb.classList.remove('flx');
    }
  }

  
  const quantity = document.querySelector(".quantity_sel");
  const quantity_inp = document.querySelector(".product-variant-quantity");
  const po = document.querySelector("po");
   
  if(quantity && quantity != undefined){
    quantity.addEventListener('change', function(){
    //   setTimeout(() => {
    //   const currency = po.innerHTML.charAt(0);
    //   const one_pr = parseFloat(po.innerHTML.substring(1))
    //   var q_val = this.value;
    //   quantity_inp.value = q_val;
    //   var to_change = parseFloat(one_pr * parseFloat(q_val)).toFixed(2);
    //   po.innerHTML = currency + to_change;
    // }, 500);
      setTimeout(() => {
        quantity.closest('.accordion').querySelector('details').removeAttribute('open');
        quantity.closest('.accordion').querySelector('summary').removeAttribute('aria-expanded');
        // acc.querySelector('.variant_name_flx').innerHTML = var_.value;
        quantity.closest('.accordion').querySelector('svg').style.display = 'block';
      }, 1000);
    });
  }
  
  const packaging = document.querySelectorAll('[name="attributes[Pick your packaging]"]');
  const pick_packaging = document.querySelector('[name="attributes[Pick packaging option]"]');

  if(packaging && packaging != undefined){
    packaging.forEach((package) => {
      package.addEventListener('click', function(e){
        var q_val = this.value;
        pick_packaging.value = q_val;
      });
    });
  }

  
  function smooth_(elm){
    var details = elm.closest('.accordion').querySelector('details');

    console.log(details.hasAttribute(open), 'open')
    // (".accordion__content").style.animation = 'none';
    // elm.closest('.accordion').querySelector(".accordion__content").style.animation = 'animateOpen 1s ease-in-out';
  }

  

  const form_summary = document.querySelectorAll("product-info .product-form__input .accordion summary");

  if(form_summary && form_summary != undefined){
    form_summary.forEach((summ_) => {
      summ_.addEventListener('click', function(){
        smooth_(summ_);
      });
    })
  }

  
  const multi = document.querySelector(".multi-qty-container");
  var go_ = 0;

  if(multi && multi != undefined){
    go_ = 1;
  }


  if(go_ == 0){
    const variant_selects = document.querySelectorAll("variant-selects input");

    if(variant_selects && variant_selects != undefined){
      variant_selects.forEach((var_) => {
        var_.addEventListener('click', function(){
          var acc = var_.closest('.accordion');


          setTimeout(() => {
            acc.querySelector('details').removeAttribute('open');
            acc.querySelector('summary').removeAttribute('aria-expanded');
            acc.querySelector('.variant_name_flx').innerHTML = var_.value;
            acc.querySelector('svg').style.display = 'block';
          }, 1000);
          

          var pos = Number(acc.dataset.position);
          if(pos < 3){
            var to_op = pos + 1;
            var acc_to_op = document.querySelector('.accordion[data-position="' + to_op + '"]');
            setTimeout(() => {
              acc_to_op.querySelector('details').setAttribute('open','');
              acc_to_op.querySelector('summary').setAttribute('aria-expanded', true);
            }, 1000);
          }
        });
      });
    }
  }

  const read_more_btn = document.querySelector(".product__description_more .icon-wrap");
  if(read_more_btn && read_more_btn != undefined){
    read_more_btn.addEventListener('click', function(){      
      document.querySelector('.product__info-container .product__description').classList.toggle('expand');
      this.classList.toggle('ov');
    });
  }
  
  if(document.querySelector('.product__description .check-height')){
  if (document.querySelector('.product__description .check-height').offsetHeight < 60) {
    read_more_btn.style.display = 'none';
  }
}
  

  const deferred_media = document.querySelectorAll("deferred-media");
  const tabs = document.querySelectorAll(".video-section button.tablinks");

  if(tabs && tabs != undefined){

    tabs.forEach((tab) => {
      tab.addEventListener('click', function(){
        var attr = tab.getAttribute("onclick").replace("openTab(event, '",'').replace("')",'');
        var deferred = document.querySelector('#'+attr+' deferred-media');
        loop_deff(deferred)
      });
    });
  } 

  loop_all(deferred_media);
  window.addEventListener('scroll', () => {
    loop_all(deferred_media);
    if (thumb && thumb != undefined){
      var viewed = isproInViewport(pro_view);
  
      if(viewed === true){
        // thumb.classList.add('flx');
      }else{
        // thumb.classList.remove('flx');
      }
    }
  });

  // add page class based on last path url
  var currentUrls = window.location.href.split('/');
  var currentUrlPath = currentUrls[currentUrls.length - 1] || 'homepage';
  
  if (currentUrls[3].includes('blogs') && currentUrls.length === 6) {
    // INDIVIDUAL BLOG;
    currentUrlPath = 'blog';
  }

  document.querySelector('main').classList.add('moro-' + currentUrlPath);

    const pc_banner = document.querySelector(".shopify-pc__banner__wrapper");
    if(pc_banner && pc_banner != undefined){

      pc_banner.querySelector('.shopify-pc__banner__btn-accept').addEventListener('click', function() {
        closeBanner();
      });
      pc_banner.querySelector('.shopify-pc__banner__btn-decline').addEventListener('click', function() {
        closeBanner();
      });
    }
    function closeBanner(){
      document.querySelector('#shopify-pc__banner').style.display = 'none';
    }
  
  

    // const one_pr = parseFloat(po.innerHTML.substring(1));
    const one_pr = po ? parseFloat(po.innerHTML.substring(1)) : "";

  
    const quantity_multi = document.querySelectorAll(".quantity-multi");
    const subscriptionRadio = document.querySelector('[value="subscribe"]');
    const oneTimeRadio = document.querySelector('[value="onetime"]');
    // const discountedPriceElement = document.querySelector(".discounted-price");
    // const subscriptionPriceElement = document.querySelector(".subscription-price");
    // const oneTimePriceElement = document.querySelector(".original_price"); // Element for one-time price
    const recurringElement = document.querySelector(".subscription-details"); // New selector for refill quantity & price
    // const currency = po.innerHTML.charAt(0);
    const currency = po ? po.innerHTML.charAt(0) : "";
    const deliverySelect = document.querySelector(".subscription-selling-plan");


    
    if (quantity_multi && quantity_multi !== undefined) {
        quantity_multi.forEach((quantity) => {
            quantity.addEventListener("click", function (e) {
                let discountedPriceElement = document.querySelector(".discounted-price");
                let subscriptionPriceElement = document.querySelector(".subscription-price");
                let oneTimePriceElement = document.querySelector(".original_price"); // Element for one-time price
                e.preventDefault();
    
                // Get current quantity and variant ID
                const val = quantity.querySelector(".quantity__input").value;
                const id = quantity.dataset.varid;
    
                // Update hidden input for cart submission
                document
                    .querySelector(".product-variant-quantity-" + id)
                    .setAttribute("value", val);
    
                let totalRefillQuantity = 0;
                let refillTotalPrice = 0;
                let caseTotalPrice = 0;
                let totalPrice = 0;
                let ids = [];
    
                // Calculate total price and quantities
                document.querySelectorAll(".quantity-multi").forEach((qty) => {
                    const val_ = parseInt(qty.querySelector(".quantity__input").value) || 0;
                    const price = parseInt(qty.dataset.price) || 0;
                    const id = parseInt(qty.dataset.prodid);
                    const isRefill = qty.classList.contains("quantity----Pick");
    
                    if (val_ > 0) {
                        if (isRefill) {
                            totalRefillQuantity += val_;
                            refillTotalPrice += val_ * price;
                        } else {
                            caseTotalPrice += val_ * price;
                        }
                        totalPrice += val_ * price;
                        ids.push(id);
                    }
                });
    
                const totalBasePrice = parseFloat(totalPrice / 100.0).toFixed(2);
                let discountedPrice = totalBasePrice;
    
                // Always show 15% discount in the subscription box
                const subscriptionDiscountedPrice = parseFloat(totalPrice * 0.85 / 100).toFixed(2);
                if (subscriptionPriceElement) {
                    subscriptionPriceElement.textContent = currency + subscriptionDiscountedPrice;
                    if(subscriptionPriceElement.previousElementSibling){
                      subscriptionPriceElement.previousElementSibling.textContent = currency + totalBasePrice;
                      subscriptionPriceElement.previousElementSibling.classList.add("crossed-out"); 
                    }
                }
                updateSubscriptionDetails(totalRefillQuantity, refillTotalPrice);
                if (deliverySelect) {
                  deliverySelect.addEventListener("change", function () {
                      // Call update function when frequency changes
                      updateSubscriptionDetails(totalRefillQuantity, refillTotalPrice);
                  });
              }
                // Always show the one-time price
                if (oneTimePriceElement) {
                    oneTimePriceElement.textContent = currency + totalBasePrice;
                }
    
                // Apply discount only when the subscription option is selected
                if (subscriptionRadio && subscriptionRadio.checked) {
                    discountedPrice = subscriptionDiscountedPrice;
                } else {
                    discountedPrice = totalBasePrice; // Reset to original price for one-time purchase
                }
    
                // Update price display
                if (po) {
                    po.textContent = currency + totalBasePrice;
                }
    
                if (discountedPriceElement) {
                    if (subscriptionRadio && subscriptionRadio.checked) {
                        discountedPriceElement.textContent = currency + discountedPrice;
                        po.classList.add("crossed-out");
                    } else {
                        discountedPriceElement.textContent = "";
                        po.classList.remove("crossed-out");
                    }
                }
    
                // Enable/Disable Add to Cart button
                const uniq_ids = uniq(ids).length;
                function uniq(arr) {
                    return Array.from(new Set(arr));
                }
    
                const addToCartButton = document.querySelector('[name="add"]');
                if (uniq_ids > 0) {
                    addToCartButton.removeAttribute("disabled");
                } else {
                    addToCartButton.setAttribute("disabled", "disabled");
                }
    
                // Add or remove the bordered class for quantities
                if (val > 0) {
                    quantity.closest("label").classList.add("bordered");
                } else {
                    quantity.closest("label").classList.remove("bordered");
                }
            });
        });
    }
           // ✅ Function to update `.subscription-details` with refill quantity & refill price
           function updateSubscriptionDetails(totalRefillQuantity, refillTotalPrice) {
            const recurringElement = document.querySelector(".subscription-details");
            const deliverySelect = document.querySelector(".subscription-selling-plan"); // Correct dropdown selector
        
            if (recurringElement && deliverySelect) {
                // Extract the selected text to get the week interval (e.g., "Delivery every 4 weeks")
                const selectedOptionText = deliverySelect.options[deliverySelect.selectedIndex].text;
                const selectedWeeks = parseInt(selectedOptionText.match(/\d+/)[0]) || 4; // Extract weeks from text
        
                // Calculate days to add for next recurring order
                const daysToAdd = selectedWeeks * 7;
                const currentDate = new Date();
                currentDate.setDate(currentDate.getDate() + daysToAdd);
        
                // Format the date (e.g., "13 March")
                const options = { day: "numeric", month: "long" };
                const formattedDate = currentDate.toLocaleDateString("en-GB", options);
        
                // Calculate discounted refill price
                const discountedRefillPrice = (refillTotalPrice * 0.85 / 100).toFixed(2);
                const originalRefillPrice = (refillTotalPrice / 100).toFixed(2);
        
                // Update the subscription details element
                recurringElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="256" height="256" viewBox="0 0 256 256" fill="none"><rect width="256" height="256" fill="url(#pattern0_15165_9357)"/><defs><pattern id="pattern0_15165_9357" patternContentUnits="objectBoundingBox" width="1" height="1"><use xlink:href="#image0_15165_9357" transform="translate(0.990825) scale(0.00195312) rotate(90)"/></pattern><image id="image0_15165_9357" width="512" height="512" xlink:href="data:image/png;base64,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"/></defs></svg>
                  From ${formattedDate}, you will pay ${currency}${discountedRefillPrice} every ${selectedWeeks} weeks (${totalRefillQuantity} refills)`;
            }
        }
        
    // Handle subscription and one-time radio changes
    if (subscriptionRadio && oneTimeRadio) {
        const handleRadioChange = () => {
            quantity_multi.forEach((quantity) => {
                const clickEvent = new Event("click");
                quantity.dispatchEvent(clickEvent);
            });
        };
    
        subscriptionRadio.addEventListener("change", handleRadioChange);
        oneTimeRadio.addEventListener("change", handleRadioChange);
    }
    
    // Initial calculation
    const initialClickEvent = new Event("click");
    quantity_multi.forEach((quantity) => quantity.dispatchEvent(initialClickEvent));
    
  
  });
  
  // Helper function to get the currency symbol
  function currencySymbol() {
      // Adjust based on your currency format
      return "€";
  }
  
    


// function added(ev, data, variant){
//   console.log(ev, variant);
//   if(ev.status == 200){
//     variant.closest('td').innerHTML = '<span class="added_item">Added</span>'; 
//     var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    
//     cart.renderContents(data);
//   }
// }

function loop_deff(deferred_media){
  var hidden = isHidden(deferred_media);
  if(hidden == false){
    get_vis(deferred_media);
  }
}

function loop_all(deferred_media){
  deferred_media.forEach((item) => {
    var visible = isElementInViewport(item);

    var hidden = isHidden(item);
    if(hidden == false){
      get_vis(item);
    }
  });
}

function isHidden(el) {
  return (el.offsetParent === null)
}

function get_vis(item){
  var visible = isElementInViewport(item);
  if (visible == true){
    
    if(!item.getAttribute('loaded')){
      window.pauseAllMedia();
      item.querySelector('button').click(); 
    }else{
      var video = item.querySelector('video');
      if(video.paused){
        window.pauseAllMedia();
        video.play();
      }
    }
  }
}

function isElementInViewport (el) {
  if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
  }
  var rect = el.getBoundingClientRect();
  var elem = document.body;
  var rect_body = elem.getBoundingClientRect();


  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom > 0 &&
    rect.right > 0 &&
    rect.bottom <= (window.innerHeight + 50 || document.documentElement.clientHeight + 50 || window.innerHeight || document.documentElement.clientHeight ) && 
    parseInt(rect.right) <= (window.innerWidth || document.documentElement.clientWidth || (window.innerWidth + 50) || (document.documentElement.clientWidth + 50 || rect_body.width)) 
  );
}

function isproInViewport (el) {
  if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
  }
  var rect = el.getBoundingClientRect();

  return (
    rect.top <= 72 &&
    rect.left >= 0 &&
    rect.bottom >= 125 && 
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) 
  );
}

 document.addEventListener("DOMContentLoaded", function(event) {
     // if(Weglot.getCurrentLang() == 'sv' && $('form#AnnouncementCountryForm.localization-form').find('input[name="country_code"]').val() != 'SE'){
     //   $('form#AnnouncementCountryForm.localization-form').find('input[name="country_code"]').val('SE');
     //   $('form#AnnouncementCountryForm.localization-form').submit()
     // }
   // sweden weglot market change code
   // if (typeof Weglot !== 'undefined' && Weglot.getCurrentLang() === 'sv') {
   //    const $form = $('form#AnnouncementCountryForm.localization-form');
   //    const $countryInput = $form.find('input[name="country_code"]');
    
   //    if ($form.length && $countryInput.length && $countryInput.val() !== 'SE') {
   //      $countryInput.val('SE');
   //      $form.submit();
   //    }   
   //  }
    // if (document.querySelector('.contact-form-pg .klaviyo-form-VvquiS form.klaviyo-form')) {
    //   document.querySelector('.contact-form-pg .klaviyo-form-VvquiS form.klaviyo-form').addEventListener('keydown', function (e) {
    //     if (e.key === 'Enter' && e.target.tagName === 'INPUT') {
    //       e.preventDefault(); // Prevent submission
    //     }
    //   });
    // }
 const preventEnterSubmit = () => {
  const form = document.querySelector('.contact-form-pg .klaviyo-form-VvquiS form.klaviyo-form');
  if (form) {
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName === 'INPUT') {
        e.preventDefault();
      }
    });
    clearInterval(checkForm);
  }
};

const checkForm = setInterval(preventEnterSubmit, 300);

   // const klaviyoFormInterval = setInterval(() => {
   //    const klaviyoForm = document.querySelector('.klaviyo-form-VvquiS');
   //    if (!klaviyoForm) return;
   //    // Check if Klaviyo has rendered the form fields yet
   //    const inputField = klaviyoForm.querySelector('input[aria-label="your inquiries"]');
   //    if (inputField) {
   //      // Create the textarea
   //      const textarea = document.createElement('textarea');
   //      textarea.name = 'message';
   //      textarea.rows = 4;
   //      textarea.placeholder = 'Type your message here...';
   //      textarea.style.width = '100%';
   //      textarea.style.padding = '10px';
   //      textarea.style.resize = 'vertical';
   //      // Replace the input with the textarea
   //      inputField.parentNode.replaceChild(textarea, inputField);
   //      console.log(":white_check_mark: Textarea replaced successfully.");
   //      clearInterval(klaviyoFormInterval);
   //    }
   //  }, 300);
   // const interval = setInterval(() => {
   //    const originalInput = document.querySelector('input[placeholder="your inquiries"]');
   //    if (originalInput) {
   //      originalInput.style.display = "none"; // Hide original

   //      // Create a textarea with same name so it still maps to the profile property
   //      const textarea = document.createElement("textarea");
   //      textarea.name = originalInput.name; // e.g. Inquiries_01JH4D1ZV...
   //      textarea.placeholder = "your inquiries";
   //      textarea.rows = 4;
   //      textarea.required = true;
   //      textarea.style.width = "100%";
   //      textarea.style.padding = "10px";
   //      textarea.style.marginTop = "10px";
   //      textarea.style.resize = "vertical";
   //      textarea.className = originalInput.className;

   //      originalInput.parentNode.appendChild(textarea); // Insert after hidden field
   //      clearInterval(interval);
   //    }
   //  }, 300);
  });